module.exports = __webpack_public_path__ + "img/yellow-icon(2).385c9b3c.png";